import differenceInMinutes from 'date-fns/differenceInMinutes';
import { decode } from 'jsonwebtoken';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useIdleTimer } from 'react-idle-timer';
import {
  logoutUser,
  refreshTokens,
} from '../../store/actions/user/userActions';
import { getTokens } from '../helpers/getTokensHelper';

const INACTIVE_INTERVAL = 240000;
const DEBOUNCE_TIME = 500;
const REFRESH_TIMEOUT = 60000;
const INACTIVE_ALERT_POPUP_TIMEOUT = 1080000;
const EXPIRE_TIME_TOKEN_TRIGGER = 10;

export default function useRefreshHook(showAlert, alertActive) {
  const [inactiveTimerId, setInactiveTimerId] = useState(null);
  const [timerId, setTimerId] = useState(null);
  const dispatch = useDispatch();

  const showInactiveAlert = () => {
    showAlert(true);
  };

  const clearTimeouts = () => {
    clearTimeout(timerId);
    setTimerId(null);
    clearTimeout(inactiveTimerId);
    setInactiveTimerId(null);
  };

  // One minute time to do an action
  const startIdleCountdown = () =>
    setTimerId(
      setTimeout(() => {
        dispatch(logoutUser());
        showAlert(false);
      }, REFRESH_TIMEOUT),
    );

  const startIdleAlertShowCountdown = () =>
    setInactiveTimerId(
      setTimeout(() => {
        showInactiveAlert();
        startIdleCountdown();
      }, INACTIVE_ALERT_POPUP_TIMEOUT),
    );

  // Idle callback
  const handleOnIdle = () => {
    const { JwtToken, JwtRefreshToken } = getTokens();
    if (JwtToken) {
      dispatch(
        refreshTokens({
          data: {
            JwtToken,
            JwtRefreshToken,
          },
        }),
      );
      startIdleAlertShowCountdown();
    }
  };

  // Active callback (from idle to active state)
  const handleOnActive = () => {
    const { JwtToken } = getTokens();
    if (JwtToken) {
      if (timerId || inactiveTimerId) {
        clearTimeouts();
      }
    }
  };

  // Every action callback (mouse move, keyboard stroke, etc.)
  const handleOnAction = () => {
    const { JwtToken, JwtRefreshToken } = getTokens();
    const userLoggedIn = decode(JwtToken);
    if (userLoggedIn) {
      const timeUntilSessionExpire = differenceInMinutes(
        new Date(decode(JwtToken).exp * 1000),
        new Date(),
      );

      if (timeUntilSessionExpire < EXPIRE_TIME_TOKEN_TRIGGER && !alertActive) {
        dispatch(
          refreshTokens({
            data: {
              JwtToken,
              JwtRefreshToken,
            },
          }),
        );

        if (timerId || inactiveTimerId) {
          clearTimeouts();
        }
      }
    }
  };

  useIdleTimer({
    timeout: INACTIVE_INTERVAL,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: DEBOUNCE_TIME,
  });
}
